import React from 'react';
import { useParams } from 'react-router-dom';

const CONTACT_EMAIL = 'contact@alpes-solutions.com';
const COMPANY = 'Alpes Solutions SpA';
const COMPANY_RUT = '78.031.083-9';
const COMPANY_ADDRESS = 'Antonio Bellet 193, Oficina 302, Santiago, Providencia, Chile';
const COMPANY_WEB = 'https://alpes-solutions.com';

const content = {
  en: {
    title: 'Terms & Privacy Policy',
    articles: [
      {
        heading: 'Article 1 — Object',
        body:
          'These terms and conditions of use define the legal framework and use of the "Fidelize" application and its services.\n\nThis contract is concluded between ' +
          COMPANY +
          ' (hereinafter "The Publisher") and any individual or legal entity wishing to access the application (hereinafter "The User"). Access to the application is conditional upon acceptance of these terms.',
      },
      {
        heading: 'Article 2 — Imprint',
        body:
          'Application: Fidelize\nPublisher: ' +
          COMPANY +
          '\nRUT: ' +
          COMPANY_RUT +
          '\nAddress: ' +
          COMPANY_ADDRESS +
          '\nEmail: ' +
          CONTACT_EMAIL +
          '\nWebsite: ' +
          COMPANY_WEB,
      },
      {
        heading: 'Article 3 — Access to Services',
        body:
          'Users with internet access and a mobile device can access the Fidelize application free of charge from anywhere. The Publisher is not responsible for any expenses incurred in accessing the application.\n\nFidelize is a loyalty card application allowing users to accumulate points at partner businesses and redeem them for rewards.\n\nThe application and its services may be temporarily suspended for maintenance.',
      },
      {
        heading: 'Article 4 — User Responsibility',
        body:
          'The User is responsible for the risks related to their connection data. The User assumes full responsibility for the use of information entered in the Fidelize application. Any use of the service that results directly or indirectly in damage implies compensation in favour of the application.',
      },
      {
        heading: 'Article 5 — Publisher Responsibility',
        body:
          'Any malfunction of the server or internet network cannot be the responsibility of the Publisher. The Publisher cannot be held liable in cases of force majeure or unforeseeable acts of third parties.\n\nThe Publisher will apply all necessary measures to ensure the security and confidentiality of user data, but cannot guarantee absolute protection.',
      },
      {
        heading: 'Article 6 — Intellectual Property',
        body:
          "The content of the Fidelize application (logos, texts, graphic elements, etc.) is protected by copyright under Chile's intellectual property law (Law 17.336). Reproduction, copy, or publication of this content requires the Publisher's prior authorisation. Any commercial use is prohibited.\n\nThe Publisher reserves the right to moderate or remove content published by users at any time.",
      },
      {
        heading: 'Article 7 — Personal Data & Privacy',
        body:
          'The Publisher collects and retains only the following information for account identification and security:\n• Email address or social login identifier (Google / Apple)\n• Display name (optional, set by the user)\n• Date of birth (optional, set by the user)\n• Gender (optional, set by the user)\n• Loyalty card history: points accumulated and rewards redeemed\n• Firebase Cloud Messaging token for push notifications\n\nData Retention: User data is retained for as long as the account remains active. If an account is not accessed for more than 3 years, data may be purged.\n\nData Deletion: Users may request deletion of their account and all associated data at any time by using the "Delete my account" button in the Account section of the app, or by sending a request to ' +
          CONTACT_EMAIL +
          '. All personal data will be permanently deleted within 30 days of the request.\n\nData Sharing: User data is never sold or shared with third parties for commercial purposes.',
      },
      {
        heading: 'Article 8 — Changes to These Terms',
        body:
          'The Publisher reserves the right to modify these terms at any time. When terms are updated, access to the application will be temporarily blocked until the user reads and accepts the new conditions.',
      },
      {
        heading: 'Article 9 — Duration',
        body:
          'These terms are valid for an indefinite period and take effect from the moment the user accepts them and begins using the application.',
      },
    ],
  },
  es: {
    title: 'Términos y Política de Privacidad',
    articles: [
      {
        heading: 'Artículo 1 — Objeto',
        body:
          'Los presentes términos y condiciones de uso tienen por objeto el marco jurídico y el uso de la aplicación "Fidelize" y sus servicios.\n\nEste contrato se celebra entre ' +
          COMPANY +
          ' (en adelante "El Editor") y toda persona física o jurídica que desee acceder a la aplicación (en adelante "El Usuario"). El acceso a la aplicación está condicionado a la aceptación de estos términos.',
      },
      {
        heading: 'Artículo 2 — Pie de Imprenta',
        body:
          'Aplicación: Fidelize\nEditor: ' +
          COMPANY +
          '\nRUT: ' +
          COMPANY_RUT +
          '\nDirección: ' +
          COMPANY_ADDRESS +
          '\nCorreo: ' +
          CONTACT_EMAIL +
          '\nSitio web: ' +
          COMPANY_WEB,
      },
      {
        heading: 'Artículo 3 — Acceso a los Servicios',
        body:
          'El Usuario con internet y dispositivo móvil puede acceder gratuitamente a la aplicación Fidelize desde cualquier lugar. Los gastos de acceso no pueden ser imputados al Editor.\n\nFidelize es una aplicación de tarjetas de fidelización que permite a los usuarios acumular puntos en comercios adheridos y canjearlos por recompensas.\n\nLa aplicación y sus servicios pueden ser suspendidos temporalmente por mantenimiento.',
      },
      {
        heading: 'Artículo 4 — Responsabilidad del Usuario',
        body:
          'El Usuario es responsable de los riesgos relacionados con sus datos de conexión. El Usuario asume toda la responsabilidad del uso de la información ingresada en la aplicación Fidelize. Cualquier uso del servicio que resulte directa o indirectamente en un daño implica una compensación a favor de la aplicación.',
      },
      {
        heading: 'Artículo 5 — Responsabilidad del Editor',
        body:
          'Cualquier disfunción del servidor o de la red internet no puede imputarse al Editor. El Editor no puede ser comprometido en caso de fuerza mayor o hecho imprevisible de terceros.\n\nEl Editor aplicará todas las medidas necesarias para garantizar la seguridad y confidencialidad de los datos del Usuario, aunque no puede garantizar una protección total.',
      },
      {
        heading: 'Artículo 6 — Propiedad Intelectual',
        body:
          'El contenido de la aplicación Fidelize (logotipos, textos, elementos gráficos, etc.) está protegido por derechos de autor según la Ley 17.336 sobre propiedad intelectual de Chile. Su reproducción, copia o publicación requiere autorización previa del Editor. Todo uso comercial está prohibido.\n\nEl Editor se reserva el derecho de moderar o eliminar contenido publicado por los usuarios en cualquier momento.',
      },
      {
        heading: 'Artículo 7 — Datos Personales y Privacidad',
        body:
          'El Editor recopila y conserva únicamente la siguiente información para la identificación y seguridad de la cuenta:\n• Correo electrónico o identificador de inicio de sesión social (Google / Apple)\n• Nombre de usuario (opcional, definido por el usuario)\n• Fecha de nacimiento (opcional, definida por el usuario)\n• Sexo (opcional, definido por el usuario)\n• Historial de fidelización: puntos acumulados y recompensas canjeadas\n• Token Firebase Cloud Messaging para notificaciones push\n\nRetención de datos: Los datos del usuario se conservan mientras la cuenta esté activa. Si una cuenta no se usa durante más de 3 años, los datos pueden eliminarse.\n\nEliminación de datos: Los usuarios pueden solicitar la eliminación de su cuenta y todos los datos asociados en cualquier momento usando el botón "Eliminar mi cuenta" en la sección Cuenta de la app, o enviando una solicitud a ' +
          CONTACT_EMAIL +
          '. Todos los datos personales serán eliminados permanentemente en un plazo de 30 días.\n\nCompartir datos: Los datos del usuario nunca se venden ni comparten con terceros para fines comerciales.',
      },
      {
        heading: 'Artículo 8 — Modificaciones',
        body:
          'El Editor se reserva el derecho de modificar estos términos en cualquier momento. Cuando se actualicen, el acceso a la aplicación será bloqueado temporalmente hasta que el usuario lea y acepte las nuevas condiciones.',
      },
      {
        heading: 'Artículo 9 — Duración',
        body:
          'Estos términos son válidos por tiempo indefinido y surten efecto desde el momento en que el usuario los acepta y comienza a usar la aplicación.',
      },
    ],
  },
  fr: {
    title: "Conditions d'utilisation & Politique de confidentialité",
    articles: [
      {
        heading: 'Article 1 — Objet',
        body:
          "Les présentes conditions générales d'utilisation ont pour objet le cadre juridique et l'utilisation de l'application \"Fidelize\" et de ses services.\n\nCe contrat est conclu entre " +
          COMPANY +
          " (ci-après \"L'Éditeur\") et toute personne physique ou morale souhaitant accéder à l'application (ci-après \"L'Utilisateur\"). L'accès à l'application est conditionné à l'acceptation de ces conditions.",
      },
      {
        heading: 'Article 2 — Mentions légales',
        body:
          'Application : Fidelize\nÉditeur : ' +
          COMPANY +
          '\nRUT : ' +
          COMPANY_RUT +
          '\nAdresse : ' +
          COMPANY_ADDRESS +
          '\nEmail : ' +
          CONTACT_EMAIL +
          '\nSite web : ' +
          COMPANY_WEB,
      },
      {
        heading: 'Article 3 — Accès aux services',
        body:
          "L'Utilisateur disposant d'internet et d'un appareil mobile peut accéder gratuitement à l'application Fidelize depuis n'importe où. Les coûts d'accès ne peuvent être imputés à l'Éditeur.\n\nFidelize est une application de cartes de fidélité permettant aux utilisateurs d'accumuler des points chez les commerçants partenaires et de les échanger contre des récompenses.\n\nL'application et ses services peuvent être temporairement suspendus pour maintenance.",
      },
      {
        heading: "Article 4 — Responsabilité de l'Utilisateur",
        body:
          "L'Utilisateur est responsable des risques liés à ses données de connexion. L'Utilisateur assume l'entière responsabilité de l'utilisation des informations saisies dans l'application Fidelize. Tout usage du service entraînant directement ou indirectement un dommage implique une indemnisation en faveur de l'application.",
      },
      {
        heading: "Article 5 — Responsabilité de l'Éditeur",
        body:
          "Tout dysfonctionnement du serveur ou du réseau internet ne peut engager la responsabilité de l'Éditeur. L'Éditeur ne peut être tenu responsable en cas de force majeure ou de fait imprévisible d'un tiers.\n\nL'Éditeur mettra en œuvre toutes les mesures nécessaires pour garantir la sécurité et la confidentialité des données de l'Utilisateur, sans pouvoir garantir une protection absolue.",
      },
      {
        heading: 'Article 6 — Propriété intellectuelle',
        body:
          "Le contenu de l'application Fidelize (logos, textes, éléments graphiques, etc.) est protégé par le droit d'auteur en vertu de la loi chilienne 17.336. Sa reproduction, copie ou publication requiert l'autorisation préalable de l'Éditeur. Tout usage commercial est interdit.\n\nL'Éditeur se réserve le droit de modérer ou de supprimer à tout moment le contenu publié par les Utilisateurs.",
      },
      {
        heading: "Article 7 — Données personnelles & Confidentialité",
        body:
          "L'Éditeur collecte et conserve uniquement les informations suivantes pour l'identification et la sécurité du compte :\n• Adresse email ou identifiant de connexion sociale (Google / Apple)\n• Nom d'utilisateur (facultatif, défini par l'utilisateur)\n• Date de naissance (facultatif, définie par l'utilisateur)\n• Sexe (facultatif, défini par l'utilisateur)\n• Historique de fidélisation : points accumulés et récompenses échangées\n• Token Firebase Cloud Messaging pour les notifications push\n\nConservation des données : Les données sont conservées tant que le compte est actif. Si un compte n'est pas utilisé pendant plus de 3 ans, il peut être automatiquement supprimé.\n\nSuppression des données : L'Utilisateur peut demander la suppression de son compte et de toutes les données associées à tout moment via le bouton \"Supprimer mon compte\" dans la section Compte de l'app, ou en envoyant une demande à " +
          CONTACT_EMAIL +
          ". Toutes les données personnelles seront définitivement supprimées dans un délai de 30 jours.\n\nPartage des données : Les données des utilisateurs ne sont jamais vendues ni partagées avec des tiers à des fins commerciales.",
      },
      {
        heading: 'Article 8 — Évolution des conditions',
        body:
          "L'Éditeur se réserve le droit de modifier ces conditions à tout moment. En cas de modification, l'accès à l'application sera temporairement bloqué jusqu'à ce que l'Utilisateur lise et accepte les nouvelles conditions.",
      },
      {
        heading: 'Article 9 — Durée',
        body:
          "Ces conditions sont valables pour une durée indéterminée et prennent effet dès leur acceptation par l'Utilisateur.",
      },
    ],
  },
  it: {
    title: 'Termini e Informativa sulla Privacy',
    articles: [
      {
        heading: 'Articolo 1 — Oggetto',
        body:
          'Le presenti condizioni generali di utilizzo definiscono il quadro giuridico e l\'uso dell\'applicazione "Fidelize" e dei suoi servizi.\n\nQuesto contratto è stipulato tra ' +
          COMPANY +
          ' (di seguito "L\'Editore") e qualsiasi persona fisica o giuridica che desideri accedere all\'applicazione (di seguito "L\'Utente"). L\'accesso all\'applicazione è subordinato all\'accettazione di queste condizioni.',
      },
      {
        heading: 'Articolo 2 — Impronta',
        body:
          'Applicazione: Fidelize\nEditore: ' +
          COMPANY +
          '\nRUT: ' +
          COMPANY_RUT +
          '\nIndirizzo: ' +
          COMPANY_ADDRESS +
          '\nEmail: ' +
          CONTACT_EMAIL +
          '\nSito web: ' +
          COMPANY_WEB,
      },
      {
        heading: 'Articolo 3 — Accesso ai Servizi',
        body:
          "L'Utente con accesso a internet e un dispositivo mobile può accedere gratuitamente all'applicazione Fidelize da qualsiasi luogo. I costi di accesso non possono essere imputati all'Editore.\n\nFidelize è un'applicazione di carte fedeltà che consente agli utenti di accumulare punti presso i commercianti partner e riscattarli in premi.\n\nL'applicazione e i suoi servizi possono essere temporaneamente sospesi per manutenzione.",
      },
      {
        heading: "Articolo 4 — Responsabilità dell'Utente",
        body:
          "L'Utente è responsabile dei rischi relativi ai propri dati di connessione. L'Utente si assume la piena responsabilità dell'utilizzo delle informazioni inserite nell'applicazione Fidelize. Qualsiasi utilizzo del servizio che provochi direttamente o indirettamente un danno implica un risarcimento a favore dell'applicazione.",
      },
      {
        heading: "Articolo 5 — Responsabilità dell'Editore",
        body:
          "Qualsiasi malfunzionamento del server o della rete internet non può essere imputato all'Editore. L'Editore non può essere ritenuto responsabile in caso di forza maggiore o atti imprevedibili di terzi.\n\nL'Editore adotterà tutte le misure necessarie per garantire la sicurezza e la riservatezza dei dati dell'Utente, senza poter garantire una protezione assoluta.",
      },
      {
        heading: 'Articolo 6 — Proprietà Intellettuale',
        body:
          "Il contenuto dell'applicazione Fidelize (loghi, testi, elementi grafici, ecc.) è protetto dal diritto d'autore ai sensi della legge cilena 17.336. La sua riproduzione, copia o pubblicazione richiede la previa autorizzazione dell'Editore. Qualsiasi uso commerciale è vietato.\n\nL'Editore si riserva il diritto di moderare o rimuovere in qualsiasi momento i contenuti pubblicati dagli Utenti.",
      },
      {
        heading: 'Articolo 7 — Dati Personali e Privacy',
        body:
          "L'Editore raccoglie e conserva solo le seguenti informazioni per l'identificazione e la sicurezza dell'account:\n• Indirizzo email o identificatore di accesso social (Google / Apple)\n• Nome visualizzato (facoltativo, impostato dall'utente)\n• Data di nascita (facoltativa, impostata dall'utente)\n• Genere (facoltativo, impostato dall'utente)\n• Storico fedeltà: punti accumulati e premi riscattati\n• Token Firebase Cloud Messaging per le notifiche push\n\nConservazione dei dati: I dati dell'Utente vengono conservati finché l'account è attivo. Se un account non viene utilizzato per più di 3 anni, i dati possono essere eliminati.\n\nCancellazione dei dati: Gli Utenti possono richiedere la cancellazione del proprio account e di tutti i dati associati in qualsiasi momento utilizzando il pulsante \"Elimina il mio account\" nella sezione Account dell'app, o inviando una richiesta a " +
          CONTACT_EMAIL +
          '. Tutti i dati personali saranno eliminati definitivamente entro 30 giorni dalla richiesta.\n\nCondivisione dei dati: I dati degli Utenti non vengono mai venduti o condivisi con terze parti per scopi commerciali.',
      },
      {
        heading: 'Articolo 8 — Modifiche alle Condizioni',
        body:
          "L'Editore si riserva il diritto di modificare queste condizioni in qualsiasi momento. Quando le condizioni vengono aggiornate, l'accesso all'applicazione sarà temporaneamente bloccato finché l'Utente non legge e accetta le nuove condizioni.",
      },
      {
        heading: 'Articolo 9 — Durata',
        body:
          "Queste condizioni sono valide per un periodo indeterminato e hanno effetto dal momento in cui l'Utente le accetta e inizia a utilizzare l'applicazione.",
      },
    ],
  },
};

const SUPPORTED_LANGS = Object.keys(content);

const Terms = () => {
  const { lang, mode } = useParams();
  const resolvedLang = SUPPORTED_LANGS.includes(lang) ? lang : 'en';
  const isApp = mode === 'white';
  const { title, articles } = content[resolvedLang];

  return (
    <>
      {isApp && (
        <style>{`html, body { background: transparent !important; margin: 0; }`}</style>
      )}
      {!isApp && (
        <style>{`
          html, body { margin: 0; padding: 0; }
          a { color: #3b95e8; }
        `}</style>
      )}
      <main style={{
        background: isApp ? 'transparent' : 'linear-gradient(160deg, #0a1628 0%, #0f1f3d 50%, #0a1628 100%)',
        color: '#e8f0fe',
        minHeight: '100vh',
        padding: isApp ? '20px 18px 40px' : '0',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        boxSizing: 'border-box',
      }}>
        {!isApp && (
          <nav style={{
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            padding: '18px 32px',
            display: 'flex', alignItems: 'center', gap: 12,
          }}>
            <a href="/" style={{ fontSize: 13, color: 'rgba(232,240,254,0.45)', textDecoration: 'none' }}>fidelize.org</a>
            <span style={{ fontSize: 12, color: 'rgba(232,240,254,0.25)' }}>/</span>
            <span style={{ fontSize: 13, color: 'rgba(232,240,254,0.65)' }}>{title}</span>
          </nav>
        )}
        <div style={{
          maxWidth: isApp ? '100%' : 720,
          margin: '0 auto',
          padding: isApp ? 0 : '48px 32px 80px',
          boxSizing: 'border-box',
        }}>
          {!isApp && (
            <>
              <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 2, color: '#3b95e8', textTransform: 'uppercase', marginBottom: 12 }}>
                Legal
              </div>
              <h1 style={{ fontSize: 'clamp(24px, 3vw, 36px)', fontWeight: 800, color: '#fff', margin: '0 0 40px', letterSpacing: -0.5 }}>
                {title}
              </h1>
            </>
          )}
          {articles.map((article) => (
            <section key={article.heading} style={{
              marginBottom: isApp ? 22 : 0,
              borderBottom: isApp ? 'none' : '1px solid rgba(255,255,255,0.06)',
              paddingBottom: isApp ? 0 : 28,
              marginTop: isApp ? 0 : 28,
            }}>
              <h2 style={{
                fontSize: isApp ? 11 : 12,
                fontWeight: 700,
                color: '#3b95e8',
                marginBottom: 8,
                marginTop: 0,
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
              }}>
                {article.heading}
              </h2>
              <p style={{
                fontSize: isApp ? 13 : 14,
                lineHeight: 1.75,
                color: 'rgba(232,240,254,0.70)',
                whiteSpace: 'pre-line',
                margin: 0,
              }}>
                {article.body}
              </p>
            </section>
          ))}
        </div>
        {!isApp && (
          <footer style={{
            borderTop: '1px solid rgba(255,255,255,0.08)',
            padding: '24px 32px',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            flexWrap: 'wrap', gap: 12,
            maxWidth: 720, margin: '0 auto',
          }}>
            <span style={{ fontSize: 12, color: 'rgba(232,240,254,0.3)' }}>© {new Date().getFullYear()} Alpes Solutions</span>
            <div style={{ display: 'flex', gap: 20 }}>
              <a href="/privacy/es" style={{ fontSize: 12, color: 'rgba(232,240,254,0.35)', textDecoration: 'none' }}>Privacidad</a>
              <a href="/" style={{ fontSize: 12, color: 'rgba(232,240,254,0.35)', textDecoration: 'none' }}>fidelize.org</a>
            </div>
          </footer>
        )}
      </main>
    </>
  );
};

export default Terms;
